$(document).ready(function () {
  $(".UpEVBox").owlCarousel({
    loop: false,
    margin: 15,
    nav: true,
    dots: true,
    autoplay: false,
    navText: ['<span class="left"></span>', '<span class="right"></span>'],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });

  $(".PastBox").owlCarousel({
    loop: false,
    margin: 15,
    nav: true,
    dots: true,
    autoplay: false,
    navText: ['<span class="left"></span>', '<span class="right"></span>'],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 2,
      },
    },
  });
});
